module.exports = __webpack_public_path__ + "img/Capsella_grandiflora.77dc78e5.jpg";